import { Component, effect, inject } from '@angular/core';
import { ALL_COMMON_MODULES } from '../../../shared';
import { CommonService } from '../../../services/common.service';
import { IUser } from '../../../interfaces/user.interface';

@Component({
    selector: 'app-footer',
    imports: [ALL_COMMON_MODULES],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {

  commonService = inject(CommonService);
  user: IUser = { userName: '', name: '' };

  constructor() {
    effect(() => {
      this.user = this.commonService.userDetail();
    });
  }

  ngOnInit() {

  }
}